// removed by extract-text-webpack-plugin
module.exports = {"container":"_2bom_rlGBmnFMG9segmWsp","tag":"_3LBUANfZO02uvQNsM1aBto","tagText":"_1bap9d6ATC5rXGk4CpUHBW","deleteTag":"_3DxPALMdvnFS96j2weOFmZ","input":"_1BNh6ola21UCcLzHkirKmU"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/Tags/styles.css
// module id = 2854
// module chunks = 0